import type { Locale } from "@borealis/layout-express";
import type { Logger } from "pino";
import React from "react";
import type { SmallboatRegistryState } from "src/server/models/SmallboatRegistryModel.ts";
import type { TradeOrgPages } from "src/types/tradeorgPages.ts";

export type AppConfig = {
  logger?: Logger;
  locale?: Locale;
  mountOrigin?: string;
  originalUrl?: string;

  assetsBaseUrl?: string;
  pageName?: TradeOrgPages;

  smallBoatState?: SmallboatRegistryState;
  helpCenter?: string;
};

const AppConfigContext = React.createContext<AppConfig | undefined>(undefined);

type AppConfigProviderProps = AppConfig & {
  children: React.ReactNode;
  appConfig: AppConfig;
};

export function AppConfigProvider(props: AppConfigProviderProps) {
  const { children, appConfig } = props;

  return <AppConfigContext value={{ ...appConfig }}>{children}</AppConfigContext>;
}

export function useAppConfig() {
  const context = React.useContext(AppConfigContext);
  if (typeof context === "undefined") {
    throw new Error("useAppConfig must be used within an AppConfigProvider");
  }
  return context;
}
